import ZigZagSeparator from "../components/ZigZagSeparator";

const Opinion = () => {
    return (
        <div className="h-fit md:h-screen w-full p-4 md:p-20 flex flex-col gap-6">
            <div className="flex flex-row gap-1 items-center justify-center">
                <h1 className="text-3xl">Tu opinión</h1>
                <h1 className="text-3xl">es importante</h1>
            </div>
            <ZigZagSeparator/>
            <form className="w-full flex flex-col gap-4">
                <input
                    type="text"
                    placeholder="Tu nombre"
                    className="border border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 bg-gray-100"
                />
                <input
                    type="text"
                    placeholder="Lugar de procedencia"
                    className="border border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 bg-gray-100"
                />
                <select
                    className="border border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 text-gray-700 bg-gray-100"
                    defaultValue=""
                >
                    <option value="" disabled>Calidad del servicio</option>
                    <option value="excelente">Excelente</option>
                    <option value="buena">Buena</option>
                    <option value="regular">Regular</option>
                    <option value="mala">Mala</option>
                    <option value="pésima">Pésima</option>
                </select>
                <input
                    type="text"
                    placeholder="Puesto"
                    className="border border-gray-300 p-3 rounded-md outline-none focus:ring-2 focus:ring-yellow-300 bg-gray-100"
                />
                <textarea
                    placeholder="Comentarios"
                    rows="3"
                    className="border border-gray-300 p-3 rounded-md resize-none outline-none focus:ring-2 focus:ring-yellow-300 bg-gray-100"
                ></textarea>
                <button
                    type="submit"
                    className="bg-yellow-400 text-white py-2 px-4 rounded-full hover:bg-black transition"
                >
                    Enviar opinión
                </button>
            </form>
        </div>
    );
};

export default Opinion;